module.exports = __webpack_public_path__ + "static/media/P2PSwapper.9817656e.sol";


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/P2PSwapper.sol
// module id = 1855
// module chunks = 0